import CalendarConfigModel from "../Models/CalendarConfigModel.js";
import CalendarDateModel from "../Models/CalendarDateModel.js";
import SelectedDatesModel from "../Models/SelectedDatesModel.js";
import {reactive, ref} from "vue";
import MultiSelectedDatesModel from "../Models/MultiSelectedDatesModel.js";

export default class DetailCalendarController
{
    /**
     * @param element {HTMLElement}
     * @param calendarConfigModel {CalendarConfigModel}
     */
    constructor(element, calendarConfigModel)
    {
        /**
         * @type {CalendarConfigModel}
         */
        this.calendarConfigModel = reactive(calendarConfigModel);
        /**
         * @type {MultiSelectedDatesModel}
         */
        this.multiSelectedDatesModel = reactive(new MultiSelectedDatesModel(this.calendarConfigModel));
        /**
         * @type {ref<SelectedDatesModel>}
         */
        this.selectedDatesModel = ref(new SelectedDatesModel(calendarConfigModel))
        this.element = element;
        this.attrs = this.workOutAttrs();
        this.showCalendar = ref(calendarConfigModel.showCalendar);
    }

    /**
     * @return {object}
     */
    workOutAttrs()
    {
        return this.element.getAttributeNames().reduce((attrs, attrName) => {
            attrs[attrName] = this.element.getAttribute(attrName);
            return attrs;
        }, {});
    }

    /**
     * @param updatedSelectedDatesModel {SelectedDatesModel}
     */
    handleSelectedDates(updatedSelectedDatesModel)
    {
        this.selectedDatesModel.value = updatedSelectedDatesModel;

        if (this.calendarConfigModel.enableMultiDestinationCalendar) {
            this.multiSelectedDatesModel.addSelectedDatesModel(updatedSelectedDatesModel);
        }
    }

    refresh()
    {
        this.handleSelectedDates([]);
        this.showCalendar.value = false;
        requestAnimationFrame(() => {
            this.toggleCalendar();
        });
    }

    /**
     * Events to listen to from the child Calendar component
     */
    getEvents()
    {
        return {
            'selected-dates': this.handleSelectedDates.bind(this)
        }
    }

    /**
     * @return {object}
     */
    getState()
    {
        return {
            calendarConfigModel: this.calendarConfigModel,
            selectedDatesModel: this.selectedDatesModel.value,
            multiSelectedDatesModel: this.multiSelectedDatesModel
        }
    }
    /**
     * Toggle the display of the calendar from the view
     */
    toggleCalendar()
    {
        this.showCalendar.value = ! this.showCalendar.value;
    }

    getViewData()
    {
        // core view data available within the component
        let viewData = {
            events: this.getEvents(),
            state: this.getState(),
            showCalendar: this.showCalendar,
            selectedDatesModel: this.selectedDatesModel,
            multiSelectedDatesModel: this.multiSelectedDatesModel,
            toggleCalendar: this.toggleCalendar.bind(this),
            refresh: this.refresh.bind(this),
            calendarConfigModel: this.calendarConfigModel
        };
        const composableProps = {
            calendarConfigModel: this.calendarConfigModel
        };
        /**
         * Add any custom view data via composables
         */
        this.calendarConfigModel.composables.forEach(composable => {
            if (typeof composable == 'function') {
                viewData = {...composable(composableProps), ...viewData};
            }
        });
        return viewData;
    }
}
